/**
 * @requires ../node_modules/basiclightbox/dist/basicLightbox.min.js
 */

'use strict';

;( () => {
	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'vimeoPlayer', () => ({

			lightbox: null,

			buildEmbedUrl( url ) {
				const path    = new URL( url ).pathname.replace( /^\//, '' ).split( '/' );
				const videoId = path[0];
				const hash    = path[1] || '';
				let   src     = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1&controls=1&playsinline=1';

				if ( hash ) src += '&h=' + hash;

				return src;
			},

			loadVideo( event ) {
				if ( event ) event.preventDefault();

				if ( this.lightbox && this.lightbox.visible() ) return;

				const url = ( event && event.currentTarget ) ? event.currentTarget.dataset.vimeoUrl : this.$el.dataset.vimeoUrl;

				if ( ! url ) return;

				if ( ! window.basicLightbox || 'function' !== typeof window.basicLightbox.create ) {
					console.error( 'basicLightbox is unavailable.' );
					return;
				}

				const wrapperEl = document.createElement( 'div' );
				const closeBtn  = document.createElement( 'button' );
				const iframe    = document.createElement( 'iframe' );

				closeBtn.type      = 'button';
				closeBtn.className = 'close icon icon--close icon--white';
				closeBtn.setAttribute( 'aria-label', 'Close video' );
				closeBtn.innerHTML = '<span class="sr-only">Close video</span>';

				iframe.src       = this.buildEmbedUrl( url );
				iframe.className = 'vimeo-lightbox-player aspect-video w-full';
				iframe.setAttribute( 'allow', 'autoplay; fullscreen; picture-in-picture' );
				iframe.setAttribute( 'allowfullscreen', '' );
				iframe.setAttribute( 'title', 'Vimeo video player' );
				iframe.setAttribute( 'frameborder', '0' );

				wrapperEl.appendChild( closeBtn );
				wrapperEl.appendChild( iframe );

				const onKeyDown = e => {
					if ( 'Escape' === e.key ) instance.close();
				};

				const instance = window.basicLightbox.create( wrapperEl, {
					onShow: () => {
						document.addEventListener( 'keydown', onKeyDown );
					},
					onClose: () => {
						document.removeEventListener( 'keydown', onKeyDown );

						// Blank src stops playback immediately without needing any SDK.
						iframe.src = '';

						if ( this.lightbox === instance ) this.lightbox = null;

						return true;
					},
				});

				if ( ! instance ) {
					console.error( 'Unable to create lightbox instance.' );
					return;
				}

				closeBtn.addEventListener( 'click', () => instance.close() );

				this.lightbox = instance;
				instance.show();
			},

			destroy() {
				if ( this.lightbox && this.lightbox.visible() ) this.lightbox.close();
			},
		}) );
	});
})();
